import { Skeleton } from 'primereact/skeleton';
import odotimg from '../assets/odot.png'
import mapimg from '../assets/BrochureImg2.png'
import qrCode from '../assets/odotQRCode.png'
import lawton from '../assets/Lawton pic.png'

export default function Home() {

    return (
        <div>
            <main className='flex-shrink-0 modular min-vh-100'>
                <div className="container py-4">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="card shadow mb-3">
                                <div className='card-header' id="blueHeader">
                                    <div className="row">
                                        <div className="col-md-3 text-center">
                                            <a href="https://oklahoma.gov/odot/" rel="noreferrer" target='_blank'><img src={odotimg} height="105" alt='ODOT Logo' /></a>
                                        </div>
                                        <div className="col-md-9">
                                            <h4>US-62 (Rogers Lane)</h4>
                                            <h4>From 82nd Street east to I-44 </h4>
                                            <h4>Lawton, OK</h4>
                                            <h4>JP 34249(04)</h4>
                                            <h5>Safety Improvement Project</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className='card-body'>

                                    <div className="row">
                                        <img src={lawton} alt=""></img>
                                    </div>

                                </div>
                                <div className='card-footer' id="blueHeader">
                                    <div className="row">
                                        <div className="col-md-3 my-1 text-center">
                                            <img src={qrCode} alt="ODOT QR Code" style={{borderRadius:"8px"}} width="100%" />
                                        </div>
                                        <div className="col-md-9 mt-3">
                                            <h4>
                                                Please use the QR code or link below to navigate to the project website.
                                            </h4>
                                            <h3><a href="https://www.odot.org/publicmeetings" target="_blank" rel="noreferrer" style={{ color: "lightblue" }}>www.odot.org/publicmeetings</a></h3>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col'>
                                            <p style={{fontSize:'12px'}}>
                                                The Oklahoma Department of Transportation (ODOT) ensures that no person or
                                                groups of persons shall, on the grounds of race, color, sex, religion, national origin,
                                                age, disability, retaliation or genetic information, be excluded from participation in,
                                                be denied the benefits of, or be otherwise subjected to discrimination under any and
                                                all programs, services, or activities administered by ODOT, its recipients,
                                                sub-recipients, and contractors. To request an accommodation please contact the
                                                ADA Coordinator at 405-521-4140 or the Oklahoma Relay Service at 1-800-722-0353.
                                                If you have any ADA or Title VI questions email ODOT-ada-titlevi@odot.org.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="card shadow mb-3">
                                <div className="card-header h4" id="blueHeader">
                                    Summary of Improvements
                                </div>
                                <div className='card-body'>
                                    <p className="m-0">
                                        The Oklahoma Department of Transportation is performing safety improvements along US-62 (Rogers Lane) in Lawton. These improvements will help increase the safety of the corridor by:
                                    </p>
                                    <ul>
                                        <li>Reducing left-turn conflict points at the following streets (by adding hooded left turns):</li>
                                        <ul>
                                            <li>NW 82nd St.</li>
                                            <li>NW 78th St.</li>
                                            <li>NW Friar Tuck Ln.</li>
                                            <li>NW 46th St.</li>
                                            <li>NW 40th St. (Median Closure)</li>
                                            <li>NW 26th St.</li>
                                            <li>NW Central Dr.</li>
                                            <li>NW Mimosa Ln.</li>
                                            <li>NW Morningside Dr.</li>
                                        </ul>
                                        <li>Adding additional left-turn storage capacity at the following streets:</li>
                                        <ul>
                                            <li>NW 67th St.</li>
                                            <li>NW 52nd St.</li>
                                            <li>NW 38th St.</li>
                                        </ul>
                                        <li>Adding widening for U-turns at the following streets:</li>
                                        <ul>
                                            <li>NW 67th St.</li>
                                            <li>Indian Trail Rd.</li>
                                        </ul>
                                        <li>Increased protection for several roadside obstacles (e.g., guardrail)</li>
                                    </ul>
                                    <p className="m-0">
                                        The hooded left-turn bays will prevent vehicles on side streets from making left turns, eliminating the conflict of pulling out in front of vehicles. The extensions of the left-turn bays will help clear the through lanes by allowing left-turning vehicles adequate room to queue, helping reduce the chances of rear-end collisions. Since the left-turn bays will restrict some movements, U-turn loons are being added at convenient locations. Loons are designed to allow cars and pickups the ability to make a U-turn at tight intersections.
                                    </p>
                                </div>
                                {/* <div className='card-footer' id="blueHeader">
                                    <h3>
                                        Please use the QR code or link to the right to navigate to the project website.
                                    </h3>
                                </div> */}
                            </div>
                        </div>

                    </div>
                    <div className="row">
                        <div className='col-lg-12 col-md-12'>
                            <div className="card shadow mb-3">
                                <div className='card-body'>
                                    <img src={mapimg} width="100%" alt='ODOT Logo' />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </main>
        </div>
    )
}